import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Fragment } from "react";

import Main from './pages/main';
import Login from './pages/user/login';
import LoginVerify from './pages/user/verify';
import EditPersonalInfo from './pages/user/editPersonalInfo';
import EditMedicalRecord1 from './pages/user/editMedicalRecord1';
import EditMedicalRecord2 from './pages/user/editMedicalRecord2';
import EditMedicalRecord3 from './pages/user/editMedicalRecord3';
import EditMedicalRecord4 from './pages/user/editMedicalRecord4';
import EditMedicalRecordVerify from './pages/user/editMedicalRecordVerify';
import VisitRequest from './pages/user/visitRequest';
import VisitRequestSuccessMsg from './pages/user/visitRequestSuccessMsg';
import ScrollToTop from './partials/ScrollToTop';
import BackDrop from './partials/BackDrop';
import SupportIcons from './partials/SupportIcons';
import Snackbar from './partials/snackbar';
import ImportModals from './partials/ImportModals';
import AuthenticatedRoute from './authenticatedRoute';
import ProtectedRoute from './protectedRoute';
import Payment from './pages/payment';
import Rules from './pages/rules';
import Activities from './pages/aboutUs/activities';
import Bylaws from './pages/aboutUs/bylaws';
import CeoResume from './pages/aboutUs/ceoResume';
import Certificates from './pages/aboutUs/certificates';
import NamingReason from './pages/aboutUs/namingReason';
import ContactUs from './pages/contactUs';
import FutureProjects from './pages/futureProjects';
import Discounts from './pages/discounts';
import VipServices from './pages/vipServices';
import Suggestions from './pages/suggestions';
import SurgeryConsultation from './pages/surgeryConsultation';
import MembershipEliteDoctors from './pages/membershipEliteDoctors';
import DoctorVisitRates from './pages/doctorVisitRates';
import VisitHistory from './pages/visitHistory';
import VisitHistoryDetails from './pages/visitHistory/chat';
import Blog from './pages/blog';
import BlogDetails from './pages/blog/details';
import Header from './partials/header/Index';


const Root = () => {

    const { token, mobile } = useSelector(state => state.login);

    return (
        <Router>
            <Fragment>

                <svg style={{display: 'none'}}>
                    <symbol id="arrowLeft" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fillRule="evenodd" d="M11.293 19.707l1.414-1.414L7.414 13H20v-2H7.414l5.293-5.293-1.414-1.414-7 7a1 1 0 000 1.414l7 7z" clipRule="evenodd"></path></symbol>
                </svg>

                <ScrollToTop />
                <BackDrop />
                <Snackbar />
                <Header />
                
                <Routes> 
                    <Route path='/login' element={<AuthenticatedRoute isAuthenticated={!!token}><Login /></AuthenticatedRoute>} />
                    <Route path='/login/verify' element={<AuthenticatedRoute isAuthenticated={!!token}>{mobile.length === 11 ? <LoginVerify /> : <Navigate replace to={ "/login" }/>}</AuthenticatedRoute>} />

                    <Route path='/edit-profile' element={ <ProtectedRoute isAuthenticated={!!token}> <EditPersonalInfo /> </ProtectedRoute> } />
                    <Route path='/medical-record' element={ <ProtectedRoute isAuthenticated={!!token}> <EditMedicalRecord1 /> </ProtectedRoute> } />
                    <Route path='/medical-record2' element={ <ProtectedRoute isAuthenticated={!!token}> <EditMedicalRecord2 /> </ProtectedRoute> } />
                    <Route path='/medical-record3' element={ <ProtectedRoute isAuthenticated={!!token}> <EditMedicalRecord3 /> </ProtectedRoute> } />
                    <Route path='/medical-record4' element={ <ProtectedRoute isAuthenticated={!!token}> <EditMedicalRecord4 /> </ProtectedRoute> } />
                    <Route path='/medical-record/verify' element={ <ProtectedRoute isAuthenticated={!!token}> <EditMedicalRecordVerify /> </ProtectedRoute> } />
                    <Route path='/visit-req' element={ <ProtectedRoute isAuthenticated={!!token}> <VisitRequest /> </ProtectedRoute> } />
                    <Route path='/visit-req/success' element={ <ProtectedRoute isAuthenticated={!!token}> <VisitRequestSuccessMsg /> </ProtectedRoute> } />
                    <Route path='/payment' element={ <ProtectedRoute isAuthenticated={!!token}> <Payment /> </ProtectedRoute> } />
                    <Route path='/visit-history' element={ <ProtectedRoute isAuthenticated={!!token}> <VisitHistory /> </ProtectedRoute> } />
                    <Route path='/visit-history/:uniqueCode' element={ <ProtectedRoute isAuthenticated={!!token}> <VisitHistoryDetails /> </ProtectedRoute> } />
                    <Route path='/rules' element={<Rules />} />
                    <Route path='/about-us/activities' element={<Activities />} />
                    <Route path='/about-us/bylaws' element={<Bylaws />} />
                    <Route path='/about-us/ceo-resume' element={<CeoResume />} />
                    <Route path='/about-us/ceo-resume/certificates' element={<Certificates />} />
                    <Route path='/about-us/naming-reason' element={<NamingReason />} />
                    <Route path='/contact-us' element={<ContactUs />} />
                    <Route path='/future-projects' element={<FutureProjects />} />
                    {/*<Route path='/discounts' element={<Discounts />} />*/}
                    <Route path='/vip-services' element={<VipServices />} />
                    <Route path='/suggestions' element={<Suggestions />} />
                    <Route path='/surgury-consultation' element={<SurgeryConsultation />} />
                    <Route path='/elite-doctors-membership' element={<MembershipEliteDoctors />} />
                    <Route path='/visit-fee' element={<DoctorVisitRates />} />

                    <Route path='/' element={<Main />} />
                    <Route path='*' element={ <Navigate replace to={ "/" }/> } /> } />

                    {/* <Route path='/blog' element={<Blog />} />
                    <Route path='/blog/:blogTitle' element={<BlogDetails />} />

                    <Route path='*' element={<Blog />} /> */}
                                      
                </Routes>
                <ImportModals />
                <SupportIcons />

            </Fragment>
        </Router>
    );

}

export default Root;
